import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { type PropsWithChildren } from 'react'

export const TanStackQueryDevTools = ({ children }: PropsWithChildren) => (
	<>
		<ReactQueryDevtools initialIsOpen={false} />
		{children}
	</>
)
